import softgamingsService from "../services/softgamings.service";

const handlers = {
    softgamings: {
        session: {
            set: "softgamings_session_set"
        }
    }
}

const initVuexState = function(state) {
    state.softgamings = {
        session: null
    };
}

const initGetters = function(getters) {
    getters.softgamings = (state => state.softgamings);
}

const initActions = function(actions) {
    actions[handlers.softgamings.session.set] = ({ commit }, session) => commit(handlers.softgamings.session.set, session);
}

const initMutations = function(mutations) {
    mutations[handlers.softgamings.session.set] = (state, session) => state.softgamings.session = session;
}

const initAppState = function(appState, store) {
    appState.softgamings = {
        session: {
            get: () => store.getters.softgamings.session,
            open: async options => {
                const session = await softgamingsService.openSession(options);
                store.dispatch(handlers.softgamings.session.set, session);
            },
            close: async () => {
                store.getters.softgamings.session && await softgamingsService.closeSession();
                store.dispatch(handlers.softgamings.session.set, null);
            }
        }
    }
}

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};


// WEBPACK FOOTER //
// ./_common/data/softgamings.js